import { ReduxState } from '../types/ReduxState';

export const initialState: ReduxState = {
  scale: 100,
}
